const OrderGroupPaymentList =()=>{
  return(
    <></>
  )
}

export default OrderGroupPaymentList